import { render, staticRenderFns } from "./mMyCollect.vue?vue&type=template&id=b23614a4&scoped=true&"
import script from "./mMyCollect.vue?vue&type=script&lang=js&"
export * from "./mMyCollect.vue?vue&type=script&lang=js&"
import style0 from "./mMyCollect.vue?vue&type=style&index=0&id=b23614a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23614a4",
  null
  
)

export default component.exports